import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroupDirective } from '@angular/forms';
import { distinctUntilChanged, filter } from 'rxjs';
import { SubSink } from 'SubSink';

@Component({
  selector: 'app-text-filter',
  templateUrl: './text-filter.component.html',
  styleUrl: './text-filter.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: false
})
export class TextFilterComponent implements OnInit, OnDestroy {
  formGroupDirective = inject(FormGroupDirective);

  @Input() name: string;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() changeCallback: (value: string) => void;
  @Input() description?: string;

  private readonly subs = new SubSink();
  private get control(): AbstractControl {
    return this.formGroupDirective.form.get(this.name);
  }


  constructor() {
  }

  ngOnInit(): void {
    this.addControl();

    this.subs.sink = this.control.valueChanges.pipe(
      distinctUntilChanged(),
      filter(() => !!this.changeCallback)
    )
      .subscribe(value => this.changeCallback(value));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.removeControl();
  }

  private addControl(): void {
    this.formGroupDirective.form.addControl(this.name, new FormControl(null), { emitEvent: false });
  }

  private removeControl(): void {
    this.formGroupDirective.form.removeControl(this.name, { emitEvent: false });
  }
}
